import {
  cookies,
  createLoader,
  getRequestContext,
  loader,
  redirect,
  revalidate,
} from "@rangojs/router";
import { SessionUser, encrypt, getSessionSecret } from "../session.js";

export const AuthLoader = createLoader(async (ctx) => {
  // POST = login attempt via load.action
  if (ctx.method === "POST" && ctx.formData) {
    const email = (ctx.formData.get("email") as string)?.trim();
    const password = ctx.formData.get("password") as string;

    if (!email || !password) {
      return {
        user: null as { email: string } | null,
        error: "Email and password are required",
      };
    }

    if (email !== "admin@admin.com" || password !== "admin") {
      return {
        user: null as { email: string } | null,
        error: "Invalid email or password",
      };
    }

    // Set encrypted session cookie
    const reqCtx = getRequestContext()!;
    const encrypted = await encrypt(JSON.stringify({ email }), getSessionSecret(reqCtx.env));
    cookies().set("session", encrypted, {
      httpOnly: true,
      sameSite: "lax",
      path: "/",
      maxAge: 86400,
    });

    throw redirect("/"); // Redirect to home on successful login
  }

  // GET = return current session
  const user = ctx.get(SessionUser);
  return { user: user ?? null, error: null };
}, true);

export const Auth = () => [
  loader(AuthLoader),
  revalidate(({ actionId }) => {
    if (actionId && (actionId.includes("#loginAction") || actionId.includes("#logoutAction")))
      return true; // Revalidate on any action
    return false;
  }),
];
